import { createFileRoute } from '@tanstack/react-router'

import { KnowledgeListRow } from '@/features/knowledge/components/knowledge-list-row'
import { useCopy } from '@/lib/copy/use-copy'
import { useKnowledge } from '@/lib/copy/use-knowledge'

export const Route = createFileRoute('/wiedza/domy')({
  component: WiedzaDomy,
})

function WiedzaDomy() {
  const { shell } = useCopy()
  const { data, isLoading, isError } = useKnowledge()
  const k = shell.knowledge

  return (
    <section className="space-y-4 p-5">
      <a
        href="/wiedza"
        className="font-mono text-hint tracking-[1.3px] text-element-ink-mute uppercase"
      >
        &larr; {k.categoryBackLabel}
      </a>
      <div>
        <h1 className="font-display text-[28px] leading-[1.05] text-element-ink italic">
          {k.sectionHouses}
        </h1>
        <p className="mt-1 text-hint text-element-ink-dim">
          {k.categoryHousesCount} wpisów · {k.categoryHousesHint}
        </p>
      </div>

      {isLoading && <p className="text-hint text-element-ink-dim">Ladowanie...</p>}
      {isError && (
        <p className="text-hint text-red-400">
          Nie udalo sie pobrac danych. Odswiez strone.
        </p>
      )}

      {data && (
        <div>
          {data.knowledge.houses.map((h) => (
            <KnowledgeListRow
              key={h.n}
              id={String(h.n)}
              href={`/wiedza/domy/${h.n}`}
              iconSlot={<span className="font-display text-[18px] italic">{h.n}</span>}
              title={h.name}
              body={h.body}
              meta={k.typeTagHouses}
            />
          ))}
        </div>
      )}
    </section>
  )
}
